import React, { useState, useEffect } from 'react'
import { Table } from 'rsuite'
import { budgetFormat } from '../../../utils/formatterUtil'
import TablePagination from 'rsuite/lib/Table/TablePagination'

export default function ListReportIssuesTable({
  schema,
  pagination,
  loading,
  onReload = () => {},
  ...props
}) {
  const { Column, HeaderCell, Cell, ColumnGroup } = Table
  const [tableData, setTableData] = useState(schema?.result?.values || [])
  const [displayLength, setDisplayLength] = useState(25)
  const [page, setPage] = useState(1)

  useEffect(() => {
    if (schema?.result?.values?.length > 0) {
      setTableData(schema?.result?.values)
    } else {
      setTableData([])
    }
  }, [schema])

  const defaultPage = 1

  const handleChangeLength = (dataKey) => {
    setPage(1)
    setDisplayLength(dataKey)
    if (typeof onReload === 'function') {
      onReload(dataKey, 1)
    }
  }

  const handleChangePage = (dataKey) => {
    setPage(dataKey)
    if (typeof onReload === 'function') {
      onReload(displayLength, dataKey)
    }
  }

  return (
    <>
      <Table
        wordWrap
        //height={400}
        autoHeight
        headerHeight={80}
        data={tableData}
        style={{ marginTop: 20 }}
        cellBordered
        bordered
        loading={props.loading}
        affixHeader
      >
        <Column resizable={true} width={80} align="center">
          <HeaderCell>ลำดับ</HeaderCell>
          <Cell>
            {(_, index) => {
              return index + 1
            }}
          </Cell>
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'เลขสัญญา'}</HeaderCell>
          <Cell dataKey="contractNumber" />
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'รหัสโครงการ'}</HeaderCell>
          <Cell dataKey="projectCode" />
        </Column>
        <Column resizable={true} width={200}>
          <HeaderCell>{'ชื่อโครงการ'}</HeaderCell>
          <Cell dataKey="projectName" />
        </Column>
        <Column resizable={true} width={200}>
          <HeaderCell>{'สถานะโครงการ'}</HeaderCell>
          <Cell dataKey="projectStatus" />
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'งบอนุมัติ'}</HeaderCell>
          <Cell align="right">
            {(rowData) => {
              return <span>{budgetFormat(rowData.projectBudget)}</span>
            }}
          </Cell>
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'องค์กรรับทุน'}</HeaderCell>
          <Cell dataKey="organizationName" />
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'ผู้รับทุน'}</HeaderCell>
          <Cell dataKey="granteeName" />
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'ผู้รับผิดชอบโครงการ'}</HeaderCell>
          <Cell dataKey="responsibleName" />
        </Column>
        <Column resizable={true} width={80}>
          <HeaderCell>{'สำนัก'}</HeaderCell>
          <Cell dataKey="department" />
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'นักวิชาการ'}</HeaderCell>
          <Cell dataKey="coordinator" />
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'ทีมตรวจ (บริษัท)'}</HeaderCell>
          <Cell dataKey="auditTeam" />
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'ผู้ตรวจสอบภายในโครงการ'}</HeaderCell>
          <Cell dataKey="auditor" />
        </Column>
        <Column resizable={true} width={100}>
          <HeaderCell>{'ใบอนุญาตเลขที่'}</HeaderCell>
          <Cell dataKey="auditorLicenseNumber" />
        </Column>
        <Column resizable={true} width={80}>
          <HeaderCell>{'เกรด'}</HeaderCell>
          <Cell dataKey="grade" />
        </Column>
        <Column resizable={true} width={300}>
          <HeaderCell>{'ผลการตรวจสอบ'}</HeaderCell>
          <Cell dataKey="auditResult" />
        </Column>
        <Column resizable={true} width={150}>
          <HeaderCell>{'ด้าน'}</HeaderCell>
          <Cell dataKey="issueCategory" />
        </Column>
        <Column resizable={true} width={200}>
          <HeaderCell>{'ประเด็น'}</HeaderCell>
          <Cell dataKey="issue" />
        </Column>
        <Column resizable={true} width={100}>
          <HeaderCell>{'ความเสี่ยง'}</HeaderCell>
          <Cell dataKey="risk" />
        </Column>
        <Column resizable={true} width={300}>
          <HeaderCell>{'ประเด็นที่ตรวจพบ'}</HeaderCell>
          <Cell>
            {(rowData) => {
              return <span dangerouslySetInnerHTML={{ __html: rowData.issuesDetected }}></span>
            }}
          </Cell>
        </Column>
        {/* <Column resizable={true} width={300}>
          <HeaderCell>{'ผลคำชี้แจง'}</HeaderCell>
          <Cell dataKey="explanationResult" />
        </Column> */}
        <Column resizable={true} width={300}>
          <HeaderCell>{'คำชี้แจงโครงการ'}</HeaderCell>
          <Cell>
            {(rowData) => {
              return <span dangerouslySetInnerHTML={{ __html: rowData.explanation }}></span>
            }}
          </Cell>
        </Column>
        <Column resizable={true} width={300}>
          <HeaderCell>{'ผลการติดตามการดำเนินงาน'}</HeaderCell>
          <Cell>
            {(rowData) => {
              return <span dangerouslySetInnerHTML={{ __html: rowData.trackingResults }}></span>
            }}
          </Cell>
        </Column>
        <Column resizable={true} width={300}>
          <HeaderCell>{'ความเห็นเพิ่มเติม'}</HeaderCell>
          <Cell>
            {(rowData) => {
              return (
                <span dangerouslySetInnerHTML={{ __html: rowData.trackingResultsDetail }}></span>
              )
            }}
          </Cell>
        </Column>
        <Column resizable={true} width={250}>
          <HeaderCell>{'สถานะการรายงานผล'}</HeaderCell>
          <Cell dataKey="status" />
        </Column>
        <Column resizable={true} width={200}>
          <HeaderCell>{'สถานะการติดตามผล'}</HeaderCell>
          <Cell dataKey="step" />
        </Column>
      </Table>

      <TablePagination
        lengthMenu={[
          {
            label: 25,
            value: 25,
          },
          {
            label: 50,
            value: 50,
          },
          {
            label: 100,
            value: 100,
          },
          {
            label: 200,
            value: 200,
          },
          {
            label: 400,
            value: 400,
          },
        ]}
        activePage={page || defaultPage}
        renderLengthMenu={(lengthMenu) => {
          return (
            <>
              {lengthMenu}
              {`รายการ/หน้า`}
            </>
          )
        }}
        renderTotal={(total) => {
          return <>{` ทั้งหมด ${total} รายการ`}</>
        }}
        displayLength={displayLength || 25}
        total={schema?.result?.totalSize || 0}
        onChangePage={handleChangePage}
        onChangeLength={handleChangeLength}
      />
    </>
  )
}
